import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest } from '../generalRequest';

const initialState = {
    popularQuestions : [],
    isLoading: false,
}

export const popularQuestionSlice = createSlice({
    name : 'popularQuestions',
    initialState,
    reducers:{
        setIsLoading: (state,action) => 
        {
            state.isLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(sendGeneralRequest.pending, (state) => {
            state.isLoading = true
        }) 
        .addCase(sendGeneralRequest.rejected, (state) => {
            state.isLoading = false
        }) 
        .addCase(sendGeneralRequest.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.endpoint === 'FrequentlyAskedQuestions')
                {
                    state.popularQuestions = action.payload.response.listAFQ.map(popularQuestion => {return {question: popularQuestion.question, answer: popularQuestion.answer}})             
                }
        })
    }
})

export const {setIsLoading} = popularQuestionSlice.actions
export const selectPopulartQuestionsState = (state) => state.popularQuestions;
export default popularQuestionSlice.reducer